module.exports = __webpack_public_path__ + "assets/img/81@3x.745b989c.png";